import { React, useState, useEffect, useContext } from "react";
import Button from "@mui/material/Button";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import WarehouseInfoModal from "../../../../modal/PC/stock/WarehouseInfoModal";
import styled from "styled-components";
import Select from 'react-select';
import { AppContext } from '../../../../AppStore';
import Moment from 'moment';
import { useNavigate, useLocation } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';

const WarehouseInfo = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [rows, setRows] = useState([]);
    const [columns, setColumns] = useState([]);
    const [originRows, setOriginRows] = useState([]);
    const [itemRows, setItemRows] = useState([]);
    const [itemColumns, setItemColumns] = useState([]);
    const [workplaceOption, setWorkplaceOption] = useState([]);
    const [keyword, setKeyword] = useState({
        workplace_id:0,
        search:''
    });
    const [isModalOpen, setModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [selectUpperID, setSelectUpperID] = useState(0);
    const [selectWorkplaceID, setSelectWorkplaceID] = useState(0);
    const [selectWarehouseID, setSelectWarehouseID] = useState(0);
    const [selectSectionID, setSelectSectionID] = useState(0);
    const [selectWorkplaceName, setSelectWorkplaceName] = useState('');
    const [selectWarehouseName, setSelectWarehouseName] = useState('');
    const [selectSectionName, setSelectSectionName] = useState('');
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        editor: true,
        id: false, 
        workplace_id: false,
        warehouse_id: false,
        section_id: false,
        dp_workplace_name: true,
        workplace_name: false,
        dp_warehouse_name: true,
        warehouse_name: false,
        dp_section_name: true,
        section_name: false
    });
    
    const [itemColumnVisibilityModel, setItemColumnVisibilityModel] = useState({
        id: false, 
        workplace_id: false,
        warehouse_id: false,
        section_id: false,
        item_id: false,
        item_name: true,
        item_spec: true,
        item_stock: true,
        item_use_stock: true
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        if(MenuID !== 0 && workplaceOption != []){
            handleView();
        }
    }, [keyword.workplace_id])

    useEffect(() => {
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            handleInitSelect();
            handleView();
        }
    }, [MenuID]);

    // Grid정의
    const handleSetting = () => {
        setColumns([
            (MenuUpdateExistYN === "Y"?
            {
                field: 'editor',
                headerName: '수정',
                width: 55,
                type:'actions',
                disableClickEventBubbling: true,
                getActions: (params) => [
                    <GridActionsCellItem icon={<EditIcon color={ MenuUpdateYN === "Y" ? "primary" : "grey"} />} onClick={() => {DetailClick(params)}} label="Edit" disabled={ MenuUpdateYN === "Y"? false : true } />
                ],
                headerAlign: 'center', 
                align:'center'
            } : {}),
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'workplace_id', headerName: 'workplace_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'warehouse_id', headerName: 'warehouse_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'section_id', headerName: 'section_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'dp_workplace_name', headerName: '사업장', width: 120, headerAlign: 'center', align:'left', colSpan: 3 },
            { field: 'workplace_name', headerName: '사업장', width: 120, headerAlign: 'center', align:'left' },
            { field: 'dp_warehouse_name', headerName: '창고', width: 120, headerAlign: 'center', align:'left' },
            { field: 'warehouse_name', headerName: '창고', width: 120, headerAlign: 'center', align:'left' },
            { field: 'dp_section_name', headerName: '구역', width: 120, headerAlign: 'center', align:'left' },
            { field: 'section_name', headerName: '구역', width: 120, headerAlign: 'center', align:'left' }
        ]);
        
        setItemColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'workplace_id', headerName: 'workplace_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'warehouse_id', headerName: 'warehouse_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'section_id', headerName: 'section_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_id', headerName: 'item_id', width: 0, headerAlign: 'center', align:'center' },
            { field: 'item_name', headerName: '품목', width: 200, headerAlign: 'center', align:'left' },
            { field: 'item_spec', headerName: '규격', width: 300, headerAlign: 'center', align:'left' },
            { field: 'item_stock', headerName: '재고', width: 150, headerAlign: 'center', align:'right' },
            { field: 'item_use_stock', headerName: '사용 가능 재고', width: 150, headerAlign: 'center', align:'right' }
        ]);
    }
    
    // Grid 데이터 조회
    const handleView = () => {
        axios.get('/api/p/WarehouseInfo/List',
            {
            params : {
                workplace_id : keyword.workplace_id,
                search: keyword.search
            }
        },
        { withCredentials: true }
        )
        .then((response) => {
            let array = response.data.map((item, index) => ({
                workplace_id: (typeof item.workplace_id === 'undefined')?"": item.workplace_id,
                warehouse_id: (typeof item.warehouse_id === 'undefined')?"": item.warehouse_id,
                section_id: (typeof item.section_id === 'undefined')?"": item.section_id,
                workplace_name: item.workplace_name,
                dp_workplace_name: (item.workplace_name==='')? "지정된 창고 없음" :item.workplace_name + ' '  + item.warehouse_name + ' ' + item.section_name,
                warehouse_name: item.warehouse_name,
                dp_warehouse_name: '',
                section_name: item.section_name,
                dp_section_name: ''
            }));
            array = [ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse);
            array = array.map((item, index) => ({
                id: index,
                workplace_id: item.workplace_id,
                warehouse_id: item.warehouse_id,
                section_id: item.section_id,
                workplace_name: item.workplace_name,
                dp_workplace_name: item.dp_workplace_name,
                warehouse_name: item.warehouse_name,
                dp_warehouse_name: item.dp_warehouse_name,
                section_name: item.section_name,
                dp_section_name: item.dp_section_name,
            }));
            setRows(array);
            setItemRows([]);
            setOriginRows(response.data)
        })
        .catch((error) => {
            appStore.capture();
        });
    }

    const handleInitSelect = () => {
        //사업장
        axios.get('/api/Common/WorkplaceList')
        .then((response) => {
            var array_modal = response.data.map((item, index) => 
                ({ value: item.workplace_id, label: item.workplace_name })
            );
            
            array_modal.unshift({ value: 0, label : '사업장'});
            setWorkplaceOption(array_modal);
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const handleInit = () => {
        setKeyword({
            workplace_id: 0,
            search:''
        })
        
        // Hide컬럼 숨기기.
        setColumnVisibilityModel({
            editor: true,
            id: false, 
            workplace_id: false,
            warehouse_id: false,
            section_id: false,
            dp_workplace_name: true,
            workplace_name: false,
            dp_warehouse_name: true,
            warehouse_name: false,
            dp_section_name: true,
            section_name: false
        });

        setItemColumnVisibilityModel({
            id: false, 
            workplace_id: false,
            warehouse_id: false,
            section_id: false,
            item_id: false,
            item_name: true,
            item_spec: true,
            item_stock: true,
            item_use_stock: true
        });
    };
    
    const onSelectChange = (type, value) => {
        const nextKeyword = {
            ...keyword,
            [type] : value
        };
        setKeyword(nextKeyword);
    };

    const onChange = (e)=>{
        const {name, value} = e.target;
        const nextKeyword = {
            ...keyword,
            [name]: value, 
        };
        setKeyword(nextKeyword);
    };

    const onSubmitSearch = (e) => {
        //입력 검색어는 Enter로 조회.
        if (e.key === "Enter") {
          handleView();
        }
    };

    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> 코드 Grid 선택이 바뀌면 조회됨.
        if(selectUpperID !== ''){
            setItemRows([]); // 모달과 같이 데이터를 사용하므로 일단 초기화.
            let arrayItem = originRows.map((item, index) => ({
                id: index,
                workplace_id: (typeof item.workplace_id === 'undefined')?"": item.workplace_id,
                warehouse_id: (typeof item.warehouse_id === 'undefined')?"": item.warehouse_id,
                section_id: (typeof item.section_id === 'undefined')?"": item.section_id,
                item_id: item.item_id,
                item_name: item.item_name,
                item_spec: appStore.ITEM_FULL_SPEC_MAKE(item.item_spec, item.item_width, item.item_depth, item.item_height),
                item_stock: String(item.item_stock).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
                item_use_stock: String(item.item_use_stock).replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            }));
            arrayItem = arrayItem.filter((element) => String(element.workplace_id + '-' + element.warehouse_id + '-' + element.section_id) === String(selectUpperID));
            setItemRows(arrayItem);
        }
    }, [selectUpperID])

    const DetailClick = (object) => {
        setModalOpen(true);
        setModalTitle('창고 상세');
        setSelectWorkplaceID(object.row.workplace_id);
        setSelectWarehouseID(object.row.warehouse_id);
        setSelectSectionID(object.row.section_id);
        setSelectWorkplaceName(object.row.workplace_name);
        setSelectWarehouseName(object.row.warehouse_name);
        setSelectSectionName(object.row.section_name);
    };

    const handleExcel = () => {
        var filename = '창고조회'
        axios.get('/api/p/WarehouseInfo/Excel',
        {   
            params : { workplace_id : keyword.workplace_id, search: keyword.search, file_name: filename },
            responseType:'blob'
        },
        { withCredentials: true })
        .then(function (response) {
            
            if(response.status === 200){    
                filename = filename + ' ' + appStore.YYYY_MM_DD_HH_MI_SS();
                const link = document.createElement('a');
                link.href = URL.createObjectURL(response.data);
                link.setAttribute('download', filename+'.xlsx');
                document.body.appendChild(link);
                link.click();
            }
        })
        .catch(function (error) {
            appStore.capture();
        })
    };
    
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox">
                <div className="menu-action">
                    <div className="menu-title">창고조회</div>
                    <div className="menu-button">
                    <Button 
                        onClick={ handleExcel }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#00AC47", 
                            backgroundColor: "#00AC47",
                            ":hover": { boxShadow: "2px 2px 2px #00AC47" , backgroundColor: "#00AC47", borderColor: "#00AC47"}
                        }} 
                        variant="outlined">
                        엑셀
                    </Button>
                    <Button 
                        onClick={ handleInit }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "black", 
                            backgroundColor: "black",
                            ":hover": { boxShadow: "2px 2px 2px black" , backgroundColor: "black", borderColor: "black"}
                        }} 
                        variant="outlined">
                        초기화
                    </Button>
                    <Button 
                        onClick={ handleView }
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 15, 
                            color: "white", 
                            borderColor: "#3D63AE", 
                            backgroundColor: "#3D63AE",
                            ":hover": { boxShadow: "2px 2px 2px #3D63AE" , backgroundColor: "#3D63AE", borderColor: "#3D63AE"}
                        }} 
                        variant="outlined">
                        조회
                    </Button>
                    </div>
                </div>
                <div className="menu-keyword">
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-title" >
                            사업장
                        </div>
                        <div className="menu-keyword-sub-keyword">
                            <Select className="menu-keyword-sub-keyword-select" onChange={(e) => onSelectChange('workplace_id',e.value)} value={workplaceOption.filter(function (option) { return option.value === keyword.workplace_id;  })} options={workplaceOption} noOptionsMessage={() => "조회되는 항목 없음"} />
                        </div>
                    </div>
                    <div className="menu-keyword-sub">
                        <div className="menu-keyword-sub-keyword" style={ { maxWidth: '300px' } }>
                            <input type="text" placeholder="검색" value={keyword.search} name="search" onChange={(e) => onChange(e) } onKeyPress={onSubmitSearch} autoComplete="off" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="grid">
                <div style={ {  width: '100%' } }>
                    <div className="grid_sub" style={ { width: '500px', float: 'left', fontSize: '17px' } }>
                        <DataGrid
                            className="grid_main"
                            rows={rows}
                            columns={columns}
                            rowSpanning={true}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            onRowSelectionModelChange={(newSelectedIds) => {
                                setSelectUpperID(rows[newSelectedIds].workplace_id + '-' + rows[newSelectedIds].warehouse_id + '-' + rows[newSelectedIds].section_id);
                            }}
                            columnVisibilityModel={columnVisibilityModel}
                            AlternatingRowBackground="LavenderBlush"
                            rowsPerPageOptions={[20, 50, 100]}
                        />
                    </div>
                    <div className="grid_sub" style={ { width: '20px', float: 'left' } } />
                    <div className="grid_sub" style={ { width: 'calc(100% - 520px)', float: 'right', fontSize: '17px' } }>
                        <DataGrid
                            className="grid_main"
                            rows={itemRows}
                            columns={itemColumns}
                            slots={{
                                noRowsOverlay: GridNoRow,
                            }}
                            columnVisibilityModel={itemColumnVisibilityModel}
                            AlternatingRowBackground="LavenderBlush"
                            rowsPerPageOptions={[20, 50, 100]}
                        />
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <WarehouseInfoModal
                    onClose={() => {
                        setModalOpen(false);
                    }}
                    title={modalTitle}
                    handleView={handleView}
                    workplace_id={selectWorkplaceID}
                    warehouse_id={selectWarehouseID}
                    section_id={selectSectionID}
                    workplace_name={selectWorkplaceName}
                    warehouse_name={selectWarehouseName}
                    section_name={selectSectionName}
                    MenuUpdateYN={MenuUpdateYN}
                />
            )}
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;

export default WarehouseInfo;